import React from 'react';
import Axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as Routes from '@/modules/routes';
import csrfToken from '../../shared/adminCsrf';
import RoutedSPADialog from '../../shared/RoutedSPADialog';
import StatesDialogContent, { StateOption } from '../StatesDialogContent';
import { useAlertMessageTitle, usePatchAlertMessage } from './useAlertMessageMutations';

const fetchStates = (alertMessageId: number) => Axios
  .get(Routes.get_states_admin_alert_message_path(alertMessageId, { format: 'json' }))
  .then(({ data }): StateOption[] => data ?? []);

const saveStates = (alertMessageId: number, stateIds: number[]) => Axios
  .post(
    Routes.set_states_admin_alert_message_path(alertMessageId, { format: 'json' }),
    { alert_message: { states: stateIds } },
    { headers: { 'X-CSRF-Token': csrfToken() } },
  )
  .then(({ data }): string => data?.selected ?? '');

const AlertMessageStatesModal = () => {
  const navigate = useNavigate();
  const { alertMessageId } = useParams<{ alertMessageId: string }>();
  const id = Number(alertMessageId);
  const title = useAlertMessageTitle(id);
  const patchAlertMessage = usePatchAlertMessage();

  const handleSaved = (label: string) => {
    patchAlertMessage(id, { states_selected: label });
    navigate('..');
  };

  return (
    <RoutedSPADialog>
      <StatesDialogContent
        description={title}
        fetchStates={() => fetchStates(id)}
        saveStates={stateIds => saveStates(id, stateIds)}
        title="Edit State-Specific Access"
        onSaved={handleSaved}
      />
    </RoutedSPADialog>
  );
};

export default AlertMessageStatesModal;
